import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { unlinkWorkItems, UnlinkWorkItemsPayload } from '../api/unlinkWorkItems';

export const useUnlinkWorkItemsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UnlinkWorkItemsPayload) => unlinkWorkItems(payload),
    onSuccess: () => {
      toast.success('Work item unlinked successfully');
      // Refresh tasks and specific task details
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
      queryClient.invalidateQueries({ queryKey: ['task'] });
    },
    onError: (error: any) => {
      console.error('Failed to unlink items', error);
      toast.error(error.message || 'Failed to unlink work items.');
    },
  });
};
